import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
    <p
        className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] ${
            dark ? "text-[#0392C9]" : "text-[#1BA8E0]"
        }`}
    >
        <span className="h-px w-10 bg-[#1BA8E0]" />
        {children}
    </p>
);
